import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import FloatingButtons from '../components/FloatingButtons/FloatingButtons';

const Blogs = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const blogs = [
    {
      id: 1,
      title: '10 Creative Birthday Decoration Ideas for 2024',
      excerpt: 'Discover the latest trends in birthday decorations that will make your celebration unforgettable. From balloon arches to themed setups, we\'ve got you covered.',
      image: '/images/BannerImages/bannerthree.webp',
      date: 'January 15, 2024',
      category: 'Birthday Decor',
      readTime: '5 min read'
    },
    {
      id: 2,
      title: 'How to Plan the Perfect Proposal Decoration',
      excerpt: 'Planning to pop the question? Learn how to create a romantic and memorable proposal setup that will make your special moment even more magical.',
      image: '/images/BannerImages/bannertwo.webp',
      date: 'January 10, 2024',
      category: 'Proposal Decor',
      readTime: '7 min read'
    },
    {
      id: 3,
      title: 'Anniversary Decoration: Making Memories Last',
      excerpt: 'Celebrate your love story with beautiful anniversary decorations. From intimate setups to grand celebrations, find inspiration for your special day.',
      image: '/images/BannerImages/bannerthree.webp',
      date: 'January 5, 2024',
      category: 'Anniversary Decor',
      readTime: '6 min read'
    },
    {
      id: 4,
      title: 'Baby Shower Themes: A Complete Guide',
      excerpt: 'Explore adorable baby shower themes and decoration ideas. From pastel dreams to gender-neutral setups, create the perfect welcome for your little one.',
      image: '/images/BannerImages/bannerthree.webp',
      date: 'December 28, 2023',
      category: 'Baby Shower',
      readTime: '8 min read'
    },
    {
      id: 5,
      title: 'Christmas Decoration Ideas for Your Home',
      excerpt: 'Transform your home into a winter wonderland with our Christmas decoration guide. Tips, tricks, and inspiration for a festive celebration.',
      image: '/images/HighLightImage/Christmas_Decoration_Kit.webp',
      date: 'December 20, 2023',
      category: 'Festive Decor',
      readTime: '6 min read'
    },
    {
      id: 6,
      title: 'Car Boot Decoration: Surprise Your Loved Ones',
      excerpt: 'Learn how to create stunning car boot decorations that will surprise and delight. Perfect for birthdays, anniversaries, and special occasions.',
      image: '/images/NewArrivals/img_256.webp',
      date: 'December 15, 2023',
      category: 'Car Boot Decor',
      readTime: '5 min read'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="bg-gradient-to-r from-[#8B1538] to-[#a01d47] text-white py-16 sm:py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-4">
              Our Blog
            </h1>
            <p className="text-lg sm:text-xl text-white/90 max-w-2xl mx-auto">
              Discover decoration tips, trends, and inspiration for your special occasions
            </p>
          </div>
        </section>

        {/* Featured Blog */}
        {blogs.length > 0 && (
          <section className="py-12 sm:py-16 lg:py-20">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="bg-white rounded-lg shadow-xl overflow-hidden mb-12">
                <div className="grid grid-cols-1 lg:grid-cols-2">
                  <div className="relative h-64 lg:h-auto">
                    <img
                      src={blogs[0].image}
                      alt={blogs[0].title}
                      loading="eager"
                      decoding="async"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="p-8 flex flex-col justify-center">
                    <div className="flex items-center gap-4 mb-4">
                      <span className="px-3 py-1 bg-[#8B1538] text-white text-sm font-semibold rounded-full">
                        {blogs[0].category}
                      </span>
                      <span className="text-gray-500 text-sm">{blogs[0].date}</span>
                      <span className="text-gray-500 text-sm">{blogs[0].readTime}</span>
                    </div>
                    <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
                      {blogs[0].title}
                    </h2>
                    <p className="text-gray-600 text-lg mb-6">
                      {blogs[0].excerpt}
                    </p>
                    <button
                      onClick={() => navigate(`/blog/${blogs[0].id}`)}
                      className="inline-flex items-center text-[#8B1538] font-semibold hover:underline"
                    >
                      Read More
                      <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>

              {/* Blog Grid */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {blogs.slice(1).map((blog) => (
                  <article
                    key={blog.id}
                    className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow cursor-pointer"
                    onClick={() => navigate(`/blog/${blog.id}`)}
                  >
                    <div className="relative h-48">
                      <img
                        src={blog.image}
                        alt={blog.title}
                        loading="lazy"
                        decoding="async"
                        className="w-full h-full object-cover"
                      />
                    </div>
                    <div className="p-6">
                      <div className="flex items-center gap-3 mb-3 flex-wrap">
                        <span className="px-3 py-1 bg-[#8B1538] text-white text-xs font-semibold rounded-full">
                          {blog.category}
                        </span>
                        <span className="text-gray-500 text-xs">{blog.date}</span>
                      </div>
                      <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2">
                        {blog.title}
                      </h3>
                      <p className="text-gray-600 text-sm mb-4 line-clamp-3">
                        {blog.excerpt}
                      </p>
                      <div className="flex items-center justify-between">
                        <span className="text-gray-500 text-xs">{blog.readTime}</span>
                        <button className="text-[#8B1538] font-semibold text-sm hover:underline flex items-center">
                          Read More
                          <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          </section>
        )}

        {/* Newsletter Section */}
        <section className="py-12 sm:py-16 bg-gray-50">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl sm:text-4xl font-bold text-[#8B1538] mb-4">
              Stay Updated
            </h2>
            <p className="text-gray-600 text-lg mb-8">
              Subscribe to our newsletter and never miss a blog post or decoration tip!
            </p>
            <form className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#8B1538] focus:border-transparent outline-none"
              />
              <button
                type="submit"
                className="bg-[#8B1538] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#a01d47] transition-colors"
              >
                Subscribe
              </button>
            </form>
          </div>
        </section>
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default Blogs;

